export default __webpack_public_path__ + "assets/images/fairness-df60c4959b3f7444323078f76905045e.svg";